module.exports = {
   ADD_BRANDS_LIST: "ADD_BRANDS_LIST",
   BRANDS_LOADING: "BRANDS_LOADING",

   CATEGORY_LOADING: "CATEGORY_LOADING",
   ADD_CATEGORY_LIST: "ADD_CATEGORY_LIST",

   PENDING_LOADING: "PENDING_LOADING",
   NEW_ORDER_RECEIVED: "NEW_ORDER_RECEIVED",
   ADD_PENDING_LIST: "ADD_PENDING_LIST",

   ADD_PROFILE: "ADD_PROFILE",
   PROFILE_LOADING: "PROFILE_LOADING",
   UPDATE_PLUGIN: "UPDATE_PLUGIN",

   PRODUCT_LOADING: "PRODUCT_LOADING",
   ADD_PRODUCT_LIST: "ADD_PRODUCT_LIST",
   ADD_PRODUCT: "ADD_PRODUCT",

   ORDERS_LOADING: "ORDERS_LOADING",
   ADD_ORDERS_LIST: "ADD_ORDERS_LIST",
   ADD_ORDER: "ADD_ORDER",

   CONTACT_US_LOADING: "CONTACT_US_LOADING",
   ADD_CONTACT_US_LIST: "ADD_CONTACT_US_LIST",

   LOCATIONS_LOADING: "LOCATIONS_LOADING",
   ADD_LOCATIONS_LIST: "ADD_LOCATIONS_LIST",
   ADD_LOCATION: "ADD_LOCATION",

   UPDATE_BLOCKED_APP_STATUS: "UPDATE_BLOCKED_APP_STATUS",

   DASHBOARD_LOADING: "DASHBOARD_LOADING",
   UPDATE_DASHBOARD: "UPDATE_DASHBOARD",

   UPDATE_SLIDER_LIST: "UPDATE_SLIDER_LIST",

   ADD_USERS_LIST: "ADD_USERS_LIST",
   USERS_LOADING: "USERS_LOADING",

   ADD_GALLERY_LIST: "ADD_GALLERY_LIST",
   ADD_GALLERY: "ADD_GALLERY",


}